var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"roadmap"}},[_c('div',{staticClass:"rd-title"},[_c('h2',{staticClass:"section-title"},[_vm._v("ROADMAP")])]),_c('img',{staticClass:"w-100",attrs:{"src":require("@/assets/images/roadmap.png"),"alt":"roadmap"}}),_c('div',{staticClass:"container"})])
}]

export { render, staticRenderFns }